import React from 'react'

import s from './styles.module.scss'

import { Icon } from '../../atoms'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../molecules/popover/Popover'

interface IActionPopoverProps {
  actions: React.ReactNode
}

export const ActionPopover: React.FC<IActionPopoverProps> = ({ actions }) => {
  return (
    <Popover>
      <PopoverTrigger className={s.iconContainer}>
        <Icon name='dots' size={24} />
      </PopoverTrigger>
      <PopoverContent className={s.Popover}>
        <div className={s.actionMenu}>{actions}</div>
      </PopoverContent>
    </Popover>
  )
}
